import React from "react";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import classNames from "classnames/bind";
import s from "./CustomeExpansionPanel.module.scss";
import ListComponent from "../ListComponent/ListComponent";
import { getMakeStyleClasses } from "../common/getMakeStyleClasses";

export default function ControlledExpansionPanels(props) {
  const classes = getMakeStyleClasses(compClasses);
  const cx = classNames.bind(classes);
  const [expanded, setExpanded] = React.useState(false);
  const panels = props.workEx;

  const handleChange = (panel) => (event, isExpanded) => {
    panels[panel] && (panels[panel].openState = !!isExpanded);
    setExpanded(!expanded);
  };

  return (
    <div className={classes.root}>
      {panels.map((panel, index) => (
        <div
          key={index}
          className={cx(
            classes.panelContainer,
            {
              [classes.expandedContainer]:
                String(panel.openState) === "false" ? false : !!panel.openState,
            },
            {
              [classes.vertical]: props.templateStyle === "vertical",
            }
          )}
        >
          <ExpansionHandledPanel
            data={panel}
            handleChange={handleChange(index)}
            classes={classes}
          />
        </div>
      ))}
    </div>
  );
}

const ExpansionHandledPanel = (props) => {
  const { classes, data } = props;
  const cx = classNames.bind(classes);
  const {
    organisation,
    designation,
    startDate,
    endDate,
    location,
    projects,
    openState,
  } = data;

  const handleChange = (evt, expanded) => props.handleChange(evt, expanded);
  const getPanelSummary = () => (
    <section className={cx(s.panelHeading, classes.primaryThemeColor)}>
      <Typography className={cx(classes.heading, s.heading)}>
        {organisation}
      </Typography>
      <div className={cx(s.secondaryHeading, classes.secondaryHeading)}>
        <div className={s.subHeading}>
          <span>{designation}</span>
          {startDate && endDate && <span>({`${startDate} - ${endDate}`})</span>}
        </div>
        <span>{location}</span>
      </div>
    </section>
  );
  const getPanelContent = () => (
    <section className={cx(s.contentContainer, classes.secondaryTextColor)}>
      <section className={s.projectContainer}>
        {projects && projects.length > 0 && (
          <div className={"sm-font"}>Tasks: </div>
        )}
        <ListComponent data={projects} />
      </section>
    </section>
  );

  return (
    <ExpansionPanel
      expanded={String(openState) === "false" ? false : !!openState}
      onChange={handleChange}
    >
      <ExpansionPanelSummary
        className={cx(s.expanded)}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        {getPanelSummary()}
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>{getPanelContent()}</ExpansionPanelDetails>
    </ExpansionPanel>
  );
};

const compClasses = (theme) => ({
  root: {
    width: "100%",
    paddingLeft: theme.typography.pxToRem(30),
    boxSizing: "border-box",
    position: "relative",
  },
  expanded: {
    margin: 0,
  },
  panelContainer: {
    position: "relative",
    margin: theme.typography.pxToRem(10),
    marginRight: theme.typography.pxToRem(0),
    "&:before": {
      position: "absolute",
      borderLeft: `4px solid ${theme.palette.text.secondary}`,
      top: theme.typography.pxToRem(10),
      height: "100%",
      opacity: "0.3",
      left: `-${theme.typography.pxToRem(20)}`,
      width: theme.typography.pxToRem(20),
      content: "''",
    },
    "&:after": {
      top: 0,
      left: `-${theme.typography.pxToRem(23)}`,
      width: "0.6rem",
      height: "0.6rem",
      content: "''",
      opacity: "0.3",
      position: "absolute",
      background: theme.palette.text.secondary,
      borderRadius: "50%",
    },
  },
  expandedContainer: {
    "&:before": {
      transitionProperty: "all",
      transitionDuration: "0.7s",
      opacity: "1",
      borderLeft: `4px solid ${theme.palette.primary.main}`,
      transitionTimingFunction: "cubic - bezier(0, 1, 0.5, 1)",
    },
    "&:after": {
      opacity: "1",
      background: theme.palette.primary.main,
      transitionProperty: "all",
      transitionDuration: "0.7s",
      transitionTimingFunction: "cubic - bezier(0, 1, 0.5, 1)",
    },
  },
  vertical: {
    "&:before": {
      border: "none",
    },
    "&:after": {
      top: "20px",
      left: `-${theme.typography.pxToRem(40)}`,
      width: "1.5rem",
      height: "1.5rem",
      borderRadius: "0px",
    },
  },
  heading: {
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
});
